import { render, staticRenderFns } from "./Encouragement.vue?vue&type=template&id=d28574f0&scoped=true&"
import script from "./Encouragement.vue?vue&type=script&lang=js&"
export * from "./Encouragement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28574f0",
  null
  
)

export default component.exports